import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-056cfe3a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "info"
};
const _hoisted_2 = {
  class: "info-list"
};
const _hoisted_3 = {
  class: "btn"
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("ok");

import { inject, nextTick } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'detailDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    mainWidth: {
      type: String,
      default: '73.333vw'
    }
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit
  }) {
    const props = __props;

    const handleOkClick = () => {
      nextTick(() => {
        showDialog.value = false;
        setTimeout(() => {
          emit('update:modelValue', false);
        }, 300);
      });
    };

    const showDialog = ref(false);
    watch(() => props.modelValue, val => {
      if (val) {
        setTimeout(() => {
          showDialog.value = true;
        }, 100);
      }
    });
    const currentUiStyleOptions = inject('currentUiStyleOptions');
    const currentParams = inject('currentParams');
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      return __props.modelValue ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["detail-dialog", _unref(currentUiStyleOptions).class])
      }, [_createVNode(_Transition, {
        name: "bounce"
      }, {
        default: _withCtx(() => [showDialog.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "main",
          style: _normalizeStyle(`width: ${__props.mainWidth}`)
        }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "content")]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: handleOkClick
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })])])], 4)) : _createCommentVNode("", true)]),
        _: 3
      })], 2)) : _createCommentVNode("", true);
    };
  }

});